import { getTreeStructure } from '../treeStructure';
import isFieldMissing from './IsFieldMissing';

export function countMissingFieldByPage(
  options,
  inputs,
  result,
  showAll,
  svFamily = null
) {
  const resolvedTreeStructure = getTreeStructure(svFamily ?? inputs?.sv_family);
  const itemByPage = {};
  for (const group in resolvedTreeStructure) {
    for (const page in resolvedTreeStructure[group]) {
      itemByPage[page] = 0;
      const itemList = processObject(resolvedTreeStructure[group][page]);
      itemList.forEach((field, index) => {
        if (isFieldMissing(field, options, inputs, result, showAll)) {
          itemByPage[page] += 1;
        }
      });
    }
  }
  return itemByPage;
}

export function processObject(obj, result = []) {
  if (Array.isArray(obj)) {
    obj.forEach((field, index) => {
      if (typeof field === 'string') {
        result.push(field);
      } else if (typeof field === 'object' && field !== null) {
        const firstKey = Object.keys(field)[0];
        result = processObject(field[firstKey], result);
      }
    });
  }
  return result;
}
